import { useEffect, useState } from "react";
import AceiteVolumeParcialFornecedor from "../aceite-volume-parcial-fornecedor";

import { useGlobalContext } from "hooks/useGlobalContext";
import GenericModal from "components/generic-modal";
import { TitleModal, ContainerModal } from "./styles";
import intl from "react-intl-universal";

const AceiteVolumeParcialFornecedorModal = (props: any) => {
  const [open, setOpen] = useState<boolean>(props.open);
  const { showFeedback } = useGlobalContext();

  useEffect(() => {
    setOpen(props.open);
  }, [props]);

  return (
    <GenericModal
      modalStyle={{
        width: "fit-content",
        maxHeight: "90%",
        height: "610px",
        overflowY: "scroll",
      }}
      open={open}
      // A unica forma de fechar o modal deve ser no botão de fechar.
      onRequestClose={() => {}}
    >
      <ContainerModal>
        <TitleModal>{intl.get("stocks.timeline.volumeDelta")}</TitleModal>

        <AceiteVolumeParcialFornecedor {...props} showFeedback={showFeedback} />
      </ContainerModal>
    </GenericModal>
  );
};

export default AceiteVolumeParcialFornecedorModal;
